var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"campaign-status",class:`${_vm.statusValue}`},[_vm._v(" "+_vm._s(_vm.$t(`status.${_vm.status.VAL}`))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }